import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { icon } from './ui';
const items = [{
  label: 'Wszystkie dyskusje',
  href: '/',
  icon: 'far fa-comment'
}, {
  label: 'Tagi',
  href: '/tags',
  icon: 'fas fa-th-large'
}, {
  label: 'Ogłoszenia',
  href: '/t/ogloszenia',
  icon: 'fas fa-bullhorn'
}, {
  label: 'Aktualizacje',
  href: '/t/aktualizacje',
  icon: 'fas fa-star'
}, {
  label: 'Pomoc techniczna',
  href: '/t/pomoc-techniczna',
  icon: 'fas fa-wrench'
}, {
  label: 'Rozgrywka',
  href: '/t/rozgrywka',
  icon: 'fas fa-gamepad'
}, {
  label: 'Frakcje i organizacje',
  href: '/t/frakcje-i-organizacje',
  icon: 'fas fa-users'
}, {
  label: 'Giełda',
  href: '/t/gielda',
  icon: 'fas fa-tag'
}];
export default class SiteSidebar extends Component {
  view() {
    const path = window.location.pathname.replace(/\/$/, '') || '/';
    return m("aside", {
      className: "NtSiteSidebar",
      "aria-label": "Nawigacja forum"
    }, m("div", {
      className: "NtSiteSidebar-title"
    }, m("span", null, "NOVA COMMUNITY"), m("strong", null, "Forum")), m("nav", null, items.map(item => {
      const active = path === item.href || item.href !== '/' && path.startsWith(`${item.href}/`);
      return m(Link, {
        href: item.href,
        className: active ? 'active' : ''
      }, icon(item.icon), m("span", null, item.label));
    })), m("div", {
      className: "NtSiteSidebar-shortcuts"
    }, m(Link, {
      href: "/serwer"
    }, icon('fas fa-server'), " Serwer"), m(Link, {
      href: "/ranking"
    }, icon('fas fa-trophy'), " Ranking"), m(Link, {
      href: "/novaid"
    }, icon('fas fa-id-card'), " NovaID"), m(Link, {
      href: "/premium"
    }, icon('fas fa-gem'), " Premium"), m(Link, {
      href: "/pojazdy"
    }, icon('fas fa-car'), " Pojazdy"), m(Link, {
      href: "/kary"
    }, icon('fas fa-gavel'), " Kary"), m(Link, {
      href: "/sad"
    }, icon('fas fa-balance-scale'), " S\u0105d")));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/SiteSidebar', SiteSidebar);